export default [
  {
    path: '/',
    name: '主页',
    component: () => import('@/views/portal/Index')
  },
  // 提供给第三方HIS系统跳转的页面
  {
    path: '/doctor/medical/record/index',
    name: 'his',
    component: () => import('@/views/doctor2/medical/record/index'),
    hidden: true
  },
  // 提供给yz365跳转的检测记录页面
  {
    path: '/manage/medical/record/sso',
    name: 'ManageMedicalRecordSso',
    component: () => import('@/views/manage/business/medical-record/sso'),
    hidden: true
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/errorPage/404'),
    hidden: true
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]



// WEBPACK FOOTER //
// ./src/router/base.js